import React, { useState } from "react";
import { Modal, Row } from "react-bootstrap";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import useTranslator from "../../hooks/useTranslator";
import { convertCurrencyFormat, haveValue } from "../../helper/common";
import AuthContext from "../../context/auth/AuthContext";
import AwardPropertyPopup from "./AwardPropertyPopup";

const LinkedPropertiesPopup = ({
  detailsShow,
  setDetailsShow,
  setPropData,
  property,
  selectBtn,
  tanentData,
  preselectedTanents,
  handlePropSelect,
  handleSaveChanges,
  saveTanentLoading,
  handleNavigateProfile,
}) => {
  const { _t } = useTranslator();
  const { user } = AuthContext;
  const [awardPopupModal, setAwardPopupModal] = useState(false);

  const checkSalary = (user) => {
    if (haveValue(user?.gurantor_id)) {
      if (user?.gurantor_id?.algoanIncome) {
        let monthlyIncome = parseInt(
          user?.gurantor_id?.algoanIncome?.monthlyAmount
        );
        let recorded_annual_salary = monthlyIncome * 12;

        let userIncome = parseInt(
          haveValue(user?.gurantor_id?.current_annual_income)
            ? user?.gurantor_id?.current_annual_income
            : 0
        );
        let salaryMatch = Math.round(
          (recorded_annual_salary / userIncome) * 100
        );

        return {
          matched: salaryMatch,
          salary: recorded_annual_salary,
        };
      }
    } else {
      if (user?.algoanIncome) {
        let monthlyIncome = parseInt(user?.algoanIncome?.monthlyAmount);
        let recorded_annual_salary = monthlyIncome * 12;

        let userIncome = parseInt(
          haveValue(user.current_annual_income) ? user.current_annual_income : 0
        );
        let salaryMatch = Math.round(
          (recorded_annual_salary / userIncome) * 100
        );

        return {
          matched: salaryMatch,
          salary: recorded_annual_salary,
        };
      }
    }
  };

  const calculateRentAmount = (tenantData) => {
    if (
      haveValue(tenantData?.rent_from_income) &&
      haveValue(tenantData?.rent_percentage)
    ) {
      if (tenantData?.rent_from_income == "current_annual_income") {
        return (
          convertCurrencyFormat(
            Math.floor(
              (tenantData?.tenantid?.current_annual_income || 0) *
                tenantData?.rent_percentage
            ) / 1200
          ) || 0
        );
      } else if (tenantData?.rent_from_income == "itr_amount") {
        return (
          convertCurrencyFormat(
            Math.floor(
              (tenantData?.tenantid?.itr_amount || 0) *
                tenantData?.rent_percentage
            ) / 1200
          ) || 0
        );
      } else if (tenantData?.rent_from_income == "recordedSalary") {
        const recordedSal = checkSalary(tenantData?.tenantid);
        return (
          convertCurrencyFormat(
            Math.floor(
              ((recordedSal?.salary || 0) * tenantData?.rent_percentage) / 1200
            )
          ) || 0
        );
      }
    } else {
      const doc_type = user?.rent_from || "current_annual_income";
      const rentPercentage = user?.rent_percentage;
      if (doc_type == "current_annual_income") {
        return (
          convertCurrencyFormat(
            Math.floor(
              ((tenantData?.tenantid?.current_annual_income || 0) *
                rentPercentage) /
                1200
            )
          ) || 0
        );
      } else if (doc_type == "itr_amount") {
        return (
          convertCurrencyFormat(
            Math.floor(
              ((tenantData?.tenantid?.itr_amount || 0) * rentPercentage) / 1200
            )
          ) || 0
        );
      } else if (doc_type == "recordedSalary") {
        const recordedSal = checkSalary(tenantData?.tenantid);
        return (
          convertCurrencyFormat(
            Math.floor(((recordedSal?.salary || 0) * rentPercentage) / 1200)
          ) || 0
        );
      }
    }
  };

  return (
    <>
      <Modal
        show={detailsShow}
        className="metermodal modal-xl modalWidth_set"
        centered
        onHide={(e) => {
          setDetailsShow(false);
          if (setPropData) setPropData({});
        }}
      >
        <Modal.Body>
          <div className="d-flex justify-content-between assigned_details_modal">
            <div className="d-flex align-items-center">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="20"
                height="20"
                viewBox="0 0 20 20"
                fill="none"
              >
                <path
                  d="M10.7068 0.29279L19.7051 9.29291C20.335 9.92291 19.889 10.9999 18.9982 10.9999H17.9984V16.9999C17.9984 17.7956 17.6824 18.5587 17.1199 19.1213C16.5574 19.6839 15.7945 20 14.9989 20H13.9992V12.9999C13.9992 12.2347 13.7069 11.4984 13.182 10.9416C12.6572 10.3849 11.9394 10.0498 11.1756 10.0049L10.9997 9.99988H9.00005C8.20458 9.99988 7.44164 10.3159 6.87917 10.8786C6.31664 11.4412 6.00064 12.2042 6.00064 12.9999V20H5.00082C4.20531 20 3.4424 19.6839 2.87989 19.1213C2.31739 18.5587 2.00137 17.7956 2.00137 16.9999V10.9999H1.00156C0.111727 10.9999 -0.33519 9.92291 0.294693 9.29291L9.29299 0.29279C9.48052 0.105316 9.73476 0 9.99987 0C10.265 0 10.5193 0.105316 10.7068 0.29279ZM10.9997 11.9999C11.2649 11.9999 11.5192 12.1053 11.7067 12.2928C11.8942 12.4804 11.9995 12.7347 11.9995 12.9999V20H8.00029V12.9999C8.00029 12.755 8.09017 12.5186 8.25293 12.3356C8.41564 12.1525 8.63988 12.0356 8.88311 12.0069L9.00005 11.9999H10.9997Z"
                  fill="#253837"
                />
              </svg>
              <p className="assigned_address">
                {property?.street} - {property?.street_number}
              </p>
            </div>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="17"
              height="17"
              viewBox="0 0 17 17"
              fill="none"
              style={{ cursor: "pointer" }}
              onClick={(e) => {
                setDetailsShow(false);
                if (setPropData) setPropData({});
              }}
            >
              <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M16.7734 1.32064C16.8453 1.24881 16.9022 1.16352 16.9411 1.06966C16.98 0.975805 17 0.875207 17 0.773615C17 0.672022 16.98 0.571424 16.9411 0.477565C16.9022 0.383706 16.8453 0.298423 16.7734 0.226586C16.7016 0.15475 16.6163 0.0977657 16.5224 0.058888C16.4286 0.0200102 16.328 0 16.2264 0C16.1248 0 16.0242 0.0200102 15.9303 0.058888C15.8365 0.0977657 15.7512 0.15475 15.6794 0.226586L8.5 7.40749L1.32064 0.226586C1.24881 0.15475 1.16352 0.0977657 1.06966 0.058888C0.975805 0.0200102 0.875207 7.56923e-10 0.773615 0C0.672022 -7.56923e-10 0.571424 0.0200102 0.477565 0.058888C0.383706 0.0977657 0.298423 0.15475 0.226586 0.226586C0.15475 0.298423 0.0977657 0.383706 0.058888 0.477565C0.0200102 0.571424 -7.56923e-10 0.672022 0 0.773615C7.56923e-10 0.875207 0.0200102 0.975805 0.058888 1.06966C0.0977657 1.16352 0.15475 1.24881 0.226586 1.32064L7.40749 8.5L0.226586 15.6794C0.0815054 15.8244 0 16.0212 0 16.2264C0 16.4316 0.0815054 16.6283 0.226586 16.7734C0.371667 16.9185 0.568439 17 0.773615 17C0.97879 17 1.17556 16.9185 1.32064 16.7734L8.5 9.59251L15.6794 16.7734C15.8244 16.9185 16.0212 17 16.2264 17C16.4316 17 16.6283 16.9185 16.7734 16.7734C16.9185 16.6283 17 16.4316 17 16.2264C17 16.0212 16.9185 15.8244 16.7734 15.6794L9.59251 8.5L16.7734 1.32064Z"
                fill="black"
              />
            </svg>
          </div>

          <Row className="card-listing mt-0 custm_select_btn mt-2">
            <div className="link-property prime-selectmulti multiselect-tenant">
              <p>{_t("add/removeTenant")}</p>
              <ReactMultiSelectCheckboxes
                isMulti
                name="link_property"
                id="link_property"
                options={tanentData}
                className="basic-multi-select form-control link_prop_select"
                classNamePrefix="select"
                placeholderButtonLabel={selectBtn}
                getDropdownButtonLabel={function getDropdownButtonLabel(_ref3) {
                  return selectBtn;
                }}
                selectedOptions={preselectedTanents}
                onChange={handlePropSelect}
                defaultValue={preselectedTanents}
              />

              <button
                type="button"
                className="btn btngreen"
                onClick={handleSaveChanges}
                disabled={tanentData.length === 0 || saveTanentLoading}
              >
                {_t("saveChanges")}
              </button>
            </div>
          </Row>

          <div className="assigned_details_body ">
            <p className="linked_p_details">
              {_t("linkedTo")}
              <span>{property.sharedProfiles.length || 0}</span>
            </p>
          </div>

          <div className="mobile-single-property">
            <ul>
              {property.sharedProfiles.map((assignPropData) => (
                <li className="d-flex linked_li_details linked_li_details2">
                  <div className="d-flex w-full justifycontent">
                    <div className="linked_li_div d-flex">
                      <input className="checkbox_box" type="checkbox" />
                      <div>
                        <p className="linked_li_name">
                          {assignPropData?.tenantid?.fname || ""}{" "}
                          {assignPropData?.tenantid?.lname || ""}
                        </p>
                        <p className="linked_li_score">
                          {_t("profile")}:{" "}
                          {assignPropData?.tenantid?.paymentScores?.creditScore
                            ?.value || 0}
                        </p>
                      </div>
                    </div>
                    <div className="linked_li_rate">
                      <p>
                        {_t("maxRent")}: {calculateRentAmount(assignPropData)}{" "}
                        {haveValue(assignPropData?.rent_from_income) &&
                        haveValue(assignPropData?.rent_percentage)
                          ? ` [${assignPropData?.rent_percentage}%]`
                          : ""}
                      </p>
                    </div>
                  </div>
                  {/* award property button old */}
                  {/* {!property?.assignProperty?.some(
                  (item) => item?.tenant_id === assignPropData?.tenantid?._id
                ) && (
                  <div>
                    <button
                      className="btn btngreen"
                      onClick={(e) => handleNavigateProfile(assignPropData)}
                    >
                      {_t("awardProperty")}
                    </button>
                  </div>
                )} */}
                </li>
              ))}
            </ul>
            <div className="buttonset_css">
              {/* <button
                onClick={() => {setAwardPopupModal(true);setDetailsShow(false)}}
                type="button"
                className="btn btngreen buttonset_css_clrchange"
              >
                {_t("generateReport")}
              </button> */}
              <button
                onClick={() => {
                  setAwardPopupModal(true);
                  setDetailsShow(false);
                }}
                type="button"
                className="btn btngreen"
              >
                {_t("awardProperty")}
              </button>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      <AwardPropertyPopup
        awardPopupModal={awardPopupModal}
        setAwardPopupModal={setAwardPopupModal}
      />
    </>
  );
};

export default LinkedPropertiesPopup;
